/**
 * Browser Mode Portal Context
 *
 * Provides a portal container for Radix UI dialogs in browser mode.
 * This ensures dialog overlays are scoped to the app window, not the full viewport.
 */

import { createContext, useContext, RefObject } from 'react';

type BrowserModePortalContextValue = {
  /** The portal container element for dialogs */
  portalContainer: RefObject<HTMLDivElement | null>;
};

const BrowserModePortalContext = createContext<BrowserModePortalContextValue | null>(null);

export const BrowserModePortalProvider = BrowserModePortalContext.Provider;

/**
 * Hook to get the portal container for browser mode dialogs.
 * Returns null when not in browser mode or if the container isn't ready.
 */
export function useBrowserModePortalContainer(): HTMLDivElement | null {
  const context = useContext(BrowserModePortalContext);
  return context?.portalContainer.current ?? null;
}
